import _ from 'lodash';
import * as Yup from 'yup';
import { AIRTABLE, XANO, SUPABASE, NOTION, permissionTypes } from 'drapcode-constant';
import { loadOrganizationDetails } from '../../../common/utils/check-auth';
const {
  ATOMCHAT,
  AWS_S3,
  AWS_SES,
  AWS_SNS,
  AWS_TEXTRACT,
  BACKGROUND_TASK,
  BNG_PAYMENT,
  CHAT_GPT,
  CHATGPT_CHATBOT_MESSAGING,
  DATA_FORM_SEARCH_HISTORY,
  DATA_VIEW_ACTIVITY_TRACKER,
  DOCUSIGN,
  EMAIL_OTP_AUTHENTICATOR,
  FACEBOOK_LOGIN,
  FILE_ACTIVITY_TRACKER,
  FLUID_PAY,
  IMAGINE_PAY,
  LOAN_MANAGEMENT,
  LOGIN_WITH_BACKENDLESS,
  LOGIN_WITH_XANO,
  MAGIC_LINK_LOGIN,
  MESSAGING,
  MULTI_TENANT_SAAS,
  PLAID,
  SNIPCART,
  STRIPE_CONNECT,
  STRIPE_PAYMENT_METHODS,
  TWILIO,
  TWITTER_LOGIN,
  TWO_FACTOR_AUTHENTICATION,
  PERMISSIONS_MANAGE,
  OAUTH_2,
  AUDIT_LOG,
  AUDIT_TRAIL,
  AWS_SIGNATURE,
  EMAIL_OTP_CONSENT_VALIDATOR,
  SMS_OTP_AUTHENTICATOR,
  SMS_OTP_CONSENT_VALIDATOR,
  TEXT_ANONYMIZATION_ACTIVITY_TRACKER,
} = permissionTypes;
const restrictedPlugins = [
  ATOMCHAT,
  AWS_S3,
  AWS_SES,
  AWS_SNS,
  AWS_TEXTRACT,
  BACKGROUND_TASK,
  BNG_PAYMENT,
  CHAT_GPT,
  CHATGPT_CHATBOT_MESSAGING,
  DATA_FORM_SEARCH_HISTORY,
  DATA_VIEW_ACTIVITY_TRACKER,
  DOCUSIGN,
  FACEBOOK_LOGIN,
  FILE_ACTIVITY_TRACKER,
  FLUID_PAY,
  IMAGINE_PAY,
  LOAN_MANAGEMENT,
  LOGIN_WITH_BACKENDLESS,
  LOGIN_WITH_XANO,
  MAGIC_LINK_LOGIN,
  MESSAGING,
  MULTI_TENANT_SAAS,
  PLAID,
  OAUTH_2,
  SNIPCART,
  STRIPE_CONNECT,
  STRIPE_PAYMENT_METHODS,
  TWILIO,
  TWITTER_LOGIN,
  TWO_FACTOR_AUTHENTICATION,
  PERMISSIONS_MANAGE,
  AUDIT_LOG,
  AUDIT_TRAIL,
  AWS_SIGNATURE,
  EMAIL_OTP_CONSENT_VALIDATOR,
  SMS_OTP_AUTHENTICATOR,
  SMS_OTP_CONSENT_VALIDATOR,
  TEXT_ANONYMIZATION_ACTIVITY_TRACKER,
  EMAIL_OTP_AUTHENTICATOR,
];

export const checkToShowSaveBtn = (currentValues, oldValues) => {
  return _.isEqual(currentValues, oldValues);
};

export const checkToShowUpdateBtn = (code) => {
  let updateNotAllowedPlugins = [];
  return !updateNotAllowedPlugins.includes(code);
};

export const filterCollection = (collectionNames, finalSchema, apisSchema) => {
  const apis = [];
  collectionNames.forEach((collectionName) => {
    const selSchema = finalSchema[collectionName];
    let findAnyActive = false;
    if (selSchema) {
      findAnyActive = Object.values(selSchema.fields).find((field) => {
        return field.isEnabled;
      });
    }
    if (findAnyActive) {
      const selApi = apisSchema.find((api) => api.collectionName === collectionName);
      if (selApi) {
        apis.push({ collectionName, apis: selApi.apis });
      }
    }
  });
  return apis;
};

export const combineParametersAndRequestBody = (apisSchema, finalApisSchema) => {
  const prepareFinalApiSchema = [];
  Object.keys(finalApisSchema).forEach((collectionKey) => {
    const finalApiSchema = finalApisSchema[collectionKey];
    const apiSchema = apisSchema.find((api) => api.collectionName === collectionKey);
    const { apis } = apiSchema;
    const crudKeys = Object.keys(finalApiSchema);
    crudKeys.forEach((crudKey) => {
      const crudData = finalApiSchema[crudKey];
      if (crudData.uri) {
        const selApi = apis.find((apiKey) => {
          return apiKey.value === crudData.uri;
        });
        if (selApi) {
          crudData.parameters = selApi.parameters;
          crudData.bodyData = selApi.bodyData;
          crudData.host = selApi.host;
          crudData.customPagination = selApi.customPagination;
        }
      }
    });
  });
  return finalApisSchema;
};

export const createSchemaForPluginConfiguration = (fields, installedPluginId, pluginDetail) => {
  let schema = {};
  if (fields) {
    Object.entries(fields).forEach(([key, value]) => {
      schema[key] = value.value || value.value === false ? value.value : '';
    });
    if (installedPluginId && pluginDetail) {
      Object.keys(fields).forEach((field) => {
        schema[field] = pluginDetail.hasOwnProperty(field)
          ? pluginDetail[field]
          : schema.hasOwnProperty(field)
          ? schema[field]
          : '';
      });
    }
  }
  return schema;
};

export const prepareValidationForPluginConfiguration = (fields) => {
  let validationSchema = {};
  if (fields) {
    Object.keys(fields).forEach((field) => {
      const fieldDetail = fields[field];
      if (fieldDetail.required) {
        let yupDetail = '';
        if (fieldDetail.type === 'text' || fieldDetail.type === 'password') {
          yupDetail = Yup.string().required("Can't be blank");
        } else if (fieldDetail.type === 'number') {
          yupDetail = Yup.number().required("Can't be blank");
        } else if (fieldDetail.type === 'email') {
          yupDetail = Yup.string().email('Not a valid email').required("Can't be blank");
        }
        validationSchema[field] = yupDetail;
      }
    });
  }
  return Yup.object().shape(validationSchema);
};

export const checkPluginPermissions = (code) => {
  let newCode = '';
  switch (code) {
    case 'AMAZON_TEXTRACT':
      console.log('Matched permissions', AWS_TEXTRACT);
      newCode = AWS_TEXTRACT;
      break;
    case 'ATOM_CHAT':
      newCode = ATOMCHAT;
      break;
    default:
      newCode = code;
      break;
  }
  let willAllow = restrictedPlugins.includes(newCode);
  console.log('newCode :>> ', newCode, 'willAllow :>>', willAllow);
  if (!willAllow) {
    return true;
  }
  console.log('Not in restricted plugin');
  const permissions = loadOrganizationDetails('permissions');
  console.log(
    'permissions :>> ',
    permissions,
    'isArray(permissions) :>> ',
    Array.isArray(permissions),
  );

  /**
   * When logged in from organization as a user, permissions is an array of string
   * When logged in from organization as an admin, permissions is a JSON object
   * So, we need to check if permissions is an array of string or JSON object
   */
  willAllow = permissions
    ? Array.isArray(permissions)
      ? permissions.includes(newCode)
      : true
    : false;
  return willAllow;
};
